import React from 'react';
import { Breadcrumb } from '../../../../components/Breadcrumb';
import {
    TRAINING_URL,
    getMenuItemPath,
} from '../../../../lib/landingPage/training';
import { classes } from '../../../../lib';
import Styles from './TrainingBreadcrumb.module.less';
import {
    TrainingDataType,
    TrainingItemPath,
} from '../../../../lib/landingPage';
import { Dropdown } from '../../../Dropdown';

export type TrainingBreadcrumbProps = {
    trainingMenu: TrainingDataType;
    currentSlug: string;
    showMobileDropdown?: boolean;
};

const BreadcrumbContent = ({
    menuItemPath,
    currentSlug,
    className,
    vertical,
}: {
    menuItemPath: TrainingItemPath[];
    currentSlug: string;
    className?: string;
    vertical?: boolean;
}) => {
    if (vertical) {
        return (
            <Breadcrumb
                className={classes(
                    Styles.verticalBreadcrumb,
                    'p16 vertical left-top'
                )}>
                {
                    <Breadcrumb.Item
                        className={Styles.firstVerticalBreadcrumb}
                        key={menuItemPath[0].title}>
                        {menuItemPath[0].title}
                    </Breadcrumb.Item>
                }
                {menuItemPath.slice(1).map(item =>
                    item.slug && item.slug !== currentSlug ? (
                        <Breadcrumb.Item
                            key={item.title}
                            href={TRAINING_URL() + '/' + item.slug}>
                            {item.title}
                        </Breadcrumb.Item>
                    ) : (
                        <Breadcrumb.Item key={item.title}>
                            {item.title}
                        </Breadcrumb.Item>
                    )
                )}
            </Breadcrumb>
        );
    }
    return (
        <Breadcrumb className={classes(Styles.breadcrumb, 'td-px8', className)}>
            {menuItemPath.map(item =>
                item.slug && item.slug !== currentSlug ? (
                    <Breadcrumb.Item
                        key={item.title}
                        href={TRAINING_URL() + '/' + item.slug}>
                        {item.title}
                    </Breadcrumb.Item>
                ) : (
                    <Breadcrumb.Item key={item.title}>
                        {item.title}
                    </Breadcrumb.Item>
                )
            )}
        </Breadcrumb>
    );
};

// eslint-disable-next-line max-lines-per-function
export const TrainingBreadcrumb = ({
    trainingMenu,
    currentSlug,
    showMobileDropdown,
}: TrainingBreadcrumbProps) => {
    const menuItemPath = getMenuItemPath(trainingMenu, currentSlug);

    const [visible, setVisible] = React.useState(false);

    const handleOnVisibleChange = (visible: boolean) => {
        setVisible(visible);
    };

    return (
        <>
            <BreadcrumbContent
                className={showMobileDropdown ? 'm-hidden' : ''}
                currentSlug={currentSlug}
                menuItemPath={menuItemPath}
            />
            {menuItemPath.length > 0 && showMobileDropdown && (
                <Dropdown
                    className={classes('td-hidden', Styles.dropdown)}
                    type="text"
                    text={
                        <div
                            className={classes(
                                'horizontal left-middle semibold-alude wrap',
                                Styles.textWrap
                            )}>
                            {menuItemPath[menuItemPath.length - 1].title}
                        </div>
                    }
                    visible={visible}
                    trigger={['click']}
                    onVisibleChange={handleOnVisibleChange}
                    overlayStyle={{ display: 'flex' }}
                    overlay={
                        <BreadcrumbContent
                            currentSlug={currentSlug}
                            menuItemPath={menuItemPath}
                            vertical
                        />
                    }
                />
            )}
        </>
    );
};
